<script setup lang="ts">
import { onMounted, ref } from 'vue';
import ToolTip from '../../../ToolTip.vue';

defineProps<{
  text: string;
  inactive?: boolean;
}>();
const spanEl = ref<HTMLSpanElement | null>(null);
const showTooltip = ref(false);
onMounted(() => {
  const span = spanEl.value;
  if(!span) return;

  if(span.scrollWidth > span.clientWidth) {
    showTooltip.value = true;
    return;
  }
  showTooltip.value = false;
})
</script>
<template>
  <div class="base-popover-item" :class="{
    inactive
  }">
    <slot/>
    <span ref="spanEl" class="text">{{ text }}</span>
    <ToolTip v-if="showTooltip" :placement="'top'" :reference="spanEl">{{text}}</ToolTip>
  </div>
</template>
<style scoped>
.base-popover-item {
  width: 100%;
  height: 52px;
  padding: 16px 12px;
  display: flex;
  gap: 8px;
  align-items: center;
  cursor: pointer;
  color: #ececec;
}

.base-popover-item.inactive {
  cursor: default;
  user-select: none;
  color: #747474;
  pointer-events: none;
}

.base-popover-item.inactive .text {
  color: #747474;
}

.base-popover-item:not(.inactive):hover {
  background-color: #494949;
}

.text {
  color: #ececec;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
